import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/api/client';
import { useAuth } from '@/store/auth';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const { data } = await api.post('/auth/login', { username, password });
      login(data.access_token, data.username, data.nombre_completo, data.rol, !!data.password_temporal, data.candidato_id ?? null);
      nav(data.rol === 'CAN' && data.candidato_id ? `/candidatos/${data.candidato_id}` : '/dashboard');
    } catch (err: any) {
      setError(err?.response?.data?.detail || 'Error de conexión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-arpp-primary to-blue-900 flex items-center justify-center p-6">
      <form
        onSubmit={onSubmit}
        className="bg-white rounded-lg shadow-2xl w-full max-w-sm p-8 space-y-5"
      >
        <div className="text-center">
          <h1 className="text-2xl font-bold text-arpp-primary">ARPP-JEE</h1>
          <p className="text-xs text-gray-600 mt-1">
            Sistema Control Inscripción ERM2026
          </p>
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">DNI</label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value.trim())}
            className="w-full border rounded px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-arpp-primary"
            placeholder="8 dígitos"
            inputMode="numeric"
            autoComplete="username"
            autoFocus
            required
          />
        </div>

        <div>
          <label className="block text-xs font-medium text-gray-700 mb-1">Contraseña</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-arpp-primary"
            placeholder="Iniciales (N+AP+AM) + 001"
            autoComplete="current-password"
            required
          />
        </div>

        {error && (
          <div className="bg-red-50 border border-red-200 text-red-700 text-xs rounded p-2">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-arpp-primary text-white py-2 rounded font-medium hover:bg-blue-800 disabled:opacity-50"
        >
          {loading ? 'Ingresando…' : 'Ingresar'}
        </button>

        <p className="text-[10px] text-gray-500 text-center">
          PLT: Fernando Sandoval · Cierre JEE 16-jun-2026
        </p>
      </form>
    </div>
  );
}
